module.exports = __webpack_public_path__ + "static/media/drone360-product.ff6cd42b.jpg";